const SCROLL_CLASS = "data-table-wrap--scroll"
const AT_START_CLASS = "data-table-wrap--at-start"
const AT_END_CLASS = "data-table-wrap--at-end"
const OVERFLOW_THRESHOLD_PX = 8
const SCROLL_EDGE_THRESHOLD_PX = 4

const observed = new WeakSet()

export function hasHorizontalOverflow(wrap, thresholdPx = OVERFLOW_THRESHOLD_PX) {
  return wrap.scrollWidth - wrap.clientWidth > thresholdPx
}

export function scrollEdgeState(wrap, thresholdPx = SCROLL_EDGE_THRESHOLD_PX) {
  const maxScroll = Math.max(0, wrap.scrollWidth - wrap.clientWidth)
  const overflows = maxScroll > OVERFLOW_THRESHOLD_PX

  if (!overflows) {
    return { overflows: false, atStart: true, atEnd: true }
  }

  return {
    overflows: true,
    atStart: wrap.scrollLeft <= thresholdPx,
    atEnd: wrap.scrollLeft >= maxScroll - thresholdPx,
  }
}

function ensureScrollStructure(wrap) {
  if (wrap.querySelector(".data-table-wrap__scroll")) return wrap.querySelector(".data-table-wrap__scroll")

  const table = wrap.querySelector(".data-table")
  if (!table) return null

  const hint = document.createElement("p")
  hint.className = "data-table-wrap__hint"
  hint.textContent = document.documentElement.dataset.tableScrollHint || "Swipe for more columns"
  hint.setAttribute("aria-hidden", "true")
  hint.hidden = true

  const scroll = document.createElement("div")
  scroll.className = "data-table-wrap__scroll"
  scroll.setAttribute("tabindex", "0")
  scroll.setAttribute("role", "region")
  scroll.setAttribute("aria-label", document.documentElement.dataset.tableScrollAria || "Scrollable table")

  wrap.insertBefore(hint, table)
  wrap.insertBefore(scroll, table)
  scroll.appendChild(table)

  return scroll
}

function updateWrap(wrap) {
  const scroll = ensureScrollStructure(wrap) || wrap
  const hint = wrap.querySelector(".data-table-wrap__hint")
  const { overflows, atStart, atEnd } = scrollEdgeState(scroll)

  wrap.classList.toggle(SCROLL_CLASS, overflows)
  wrap.classList.toggle(AT_START_CLASS, overflows && atStart)
  wrap.classList.toggle(AT_END_CLASS, overflows && atEnd)

  if (hint) hint.hidden = !overflows
}

function observeWrap(wrap) {
  if (observed.has(wrap)) return
  observed.add(wrap)

  const scroll = ensureScrollStructure(wrap) || wrap
  const onChange = () => updateWrap(wrap)

  const resizeObserver = new ResizeObserver(onChange)
  resizeObserver.observe(scroll)

  const table = scroll.querySelector(".data-table")
  if (table) resizeObserver.observe(table)

  scroll.addEventListener("scroll", onChange, { passive: true })

  onChange()
}

export function initDataTableWraps(root = document) {
  root.querySelectorAll(".data-table-wrap").forEach(observeWrap)
}
